module.exports = __webpack_public_path__ + "static/media/jo.ccc968f7.svg";